// extracted by mini-css-extract-plugin
module.exports = {"timePeriod":"TimePeriodSelector_timePeriod__3YVjZ","preset":"TimePeriodSelector_preset__1emtp"};